module.exports = __webpack_public_path__ + "img/taiwan.261fc45b.svg";